import { t } from "@lingui/macro";

import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner";
import { StatusWarningIcon } from "@whoosh/design-system/src/components/icons_v2/general";

type Props = {
  clubPhoneNumber?: string;
};

export const ClosedRequestWindowBanner = ({ clubPhoneNumber }: Props) => {
  const message = `${t`The request window has closed and your request is being finalized by the club. Please contact the club for any changes.`}${
    clubPhoneNumber ? t` Contact the club at ${clubPhoneNumber}.` : ""
  }`;

  return (
    <InfoBanner
      leadingIcon={StatusWarningIcon}
      message={message}
      colorTheme="ERROR"
      testID="closed-request-window-banner"
    />
  );
};
